var map = {
	"./amex-logo.svg": "40d6",
	"./g-drive-logo.svg": "8b1a",
	"./instagram-logo.svg": "13f5",
	"./mastercard-logo.svg": "9751",
	"./svg/shopify-logo.svg": "d3e0",
	"./svg/sidebar/vidjet-logo.svg": "1ba1",
	"./svg/stripe-logo.svg": "184f",
	"./tiktok-logo.svg": "4be9",
	"./visa-logo.svg": "04b5",
	"./youtube-logo.svg": "7186"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17db";